<template>
  <AppModal :model-value="Boolean(store.quote)" :title="t('tools.shadow_trading.tokens.title')" @cancel="store.choose(false)" @update:model-value="value => { if (!value) store.choose(false); }">
    <div v-if="store.quote" class="space-y-4">
      <p>{{ t('tools.shadow_trading.tokens.summary', { start: store.quote.start_date, end: store.quote.end_date, tokens: store.quote.tokens }) }}</p>
      <p>{{ t('tools.shadow_trading.tokens.balance', { tokens: tokens.totalBalance }) }}</p>
      <p v-if="insufficient" role="status">{{ t('tools.shadow_trading.tokens.insufficient') }}</p>
      <div class="flex flex-wrap gap-2">
        <AppButton :disabled="insufficient" data-test="shadow-history-confirm" @click="store.choose(true)">{{ t('tools.shadow_trading.tokens.confirm', { tokens: store.quote.tokens }) }}</AppButton>
        <AppButton v-if="!tokens.planKeys.includes('plan-pro')" variant="outline" :to="upgradeLink" @click="store.choose(false)">{{ t('tools.shadow_trading.tokens.upgrade') }}</AppButton>
        <AppButton variant="ghost" @click="store.choose(false)">{{ t('tools.shadow_trading.tokens.cancel') }}</AppButton>
      </div>
    </div>
  </AppModal>
</template>
<script setup>
import { computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import AppModal from '@/components/ui/overlays/AppModal.vue';
import AppButton from '@/components/ui/buttons/AppButton.vue';
import { useShadowHistoryQuoteStore } from '@/stores/useShadowHistoryQuoteStore';
import { useTokenBalanceStore } from '@/stores/useTokenBalanceStore';
const store = useShadowHistoryQuoteStore();
const tokens = useTokenBalanceStore();
const route = useRoute();
const { t } = useI18n();
const insufficient = computed(() => tokens.totalBalance < (store.quote?.tokens || 0));
const upgradeLink = computed(() => ({ path: '/subscriptions', query: { intent: 'platform', plan: 'pro', return_to: route.fullPath } }));
watch(() => route.fullPath, () => store.choose(false));
</script>
